import React, { useState, useMemo } from "react";
import { Calculator, HelpCircle, Home, FileText, ChevronDown, Info } from "lucide-react";

// Tabela de emolumentos baseada na tabela oficial ARISP - São Paulo
// Lei Estadual nº 11.331, de 26 de dezembro de 2002
const TABELA_REGISTRO = [
  { de: 0, ate: 2500, emolumentos: 14.78, estado: 1.98, ipesp: 0.79, registroCivil: 0.79, tribunalJustica: 0.79, ministerioPublico: 0.79 },
  { de: 2500.01, ate: 5000, emolumentos: 22.17, estado: 3.30, ipesp: 1.59, registroCivil: 1.59, tribunalJustica: 1.59, ministerioPublico: 1.59 },
  { de: 5000.01, ate: 7500, emolumentos: 29.55, estado: 4.61, ipesp: 2.39, registroCivil: 2.39, tribunalJustica: 2.39, ministerioPublico: 2.39 },
  { de: 7500.01, ate: 10000, emolumentos: 36.94, estado: 5.93, ipesp: 3.19, registroCivil: 3.19, tribunalJustica: 3.19, ministerioPublico: 3.19 },
  { de: 10000.01, ate: 12500, emolumentos: 44.33, estado: 7.25, ipesp: 3.99, registroCivil: 3.99, tribunalJustica: 3.99, ministerioPublico: 3.99 },
  { de: 12500.01, ate: 15000, emolumentos: 51.72, estado: 8.56, ipesp: 4.79, registroCivil: 4.79, tribunalJustica: 4.79, ministerioPublico: 4.79 },
  { de: 15000.01, ate: 17500, emolumentos: 59.11, estado: 9.88, ipesp: 5.58, registroCivil: 5.58, tribunalJustica: 5.58, ministerioPublico: 5.58 },
  { de: 17500.01, ate: 20000, emolumentos: 66.49, estado: 11.20, ipesp: 6.38, registroCivil: 6.38, tribunalJustica: 6.38, ministerioPublico: 6.38 },
  { de: 20000.01, ate: 22500, emolumentos: 73.88, estado: 12.52, ipesp: 7.18, registroCivil: 7.18, tribunalJustica: 7.18, ministerioPublico: 7.18 },
  { de: 22500.01, ate: 25000, emolumentos: 81.27, estado: 13.83, ipesp: 7.98, registroCivil: 7.98, tribunalJustica: 7.98, ministerioPublico: 7.98 },
  { de: 25000.01, ate: 30000, emolumentos: 92.43, estado: 16.15, ipesp: 9.18, registroCivil: 9.18, tribunalJustica: 9.18, ministerioPublico: 9.18 },
  { de: 30000.01, ate: 35000, emolumentos: 103.59, estado: 18.47, ipesp: 10.38, registroCivil: 10.38, tribunalJustica: 10.38, ministerioPublico: 10.38 },
  { de: 35000.01, ate: 40000, emolumentos: 114.75, estado: 20.79, ipesp: 11.58, registroCivil: 11.58, tribunalJustica: 11.58, ministerioPublico: 11.58 },
  { de: 40000.01, ate: 45000, emolumentos: 125.91, estado: 23.11, ipesp: 12.78, registroCivil: 12.78, tribunalJustica: 12.78, ministerioPublico: 12.78 },
  { de: 45000.01, ate: 50000, emolumentos: 137.07, estado: 25.43, ipesp: 13.98, registroCivil: 13.98, tribunalJustica: 13.98, ministerioPublico: 13.98 },
  { de: 50000.01, ate: 55000, emolumentos: 148.23, estado: 27.75, ipesp: 15.18, registroCivil: 15.18, tribunalJustica: 15.18, ministerioPublico: 15.18 },
  { de: 55000.01, ate: 60000, emolumentos: 159.39, estado: 30.07, ipesp: 16.38, registroCivil: 16.38, tribunalJustica: 16.38, ministerioPublico: 16.38 },
  { de: 60000.01, ate: 65000, emolumentos: 170.55, estado: 32.39, ipesp: 17.58, registroCivil: 17.58, tribunalJustica: 17.58, ministerioPublico: 17.58 },
  { de: 65000.01, ate: 70000, emolumentos: 181.71, estado: 34.71, ipesp: 18.78, registroCivil: 18.78, tribunalJustica: 18.78, ministerioPublico: 18.78 },
  { de: 70000.01, ate: 75000, emolumentos: 192.87, estado: 37.03, ipesp: 19.98, registroCivil: 19.98, tribunalJustica: 19.98, ministerioPublico: 19.98 },
  { de: 75000.01, ate: 80000, emolumentos: 204.03, estado: 39.35, ipesp: 21.18, registroCivil: 21.18, tribunalJustica: 21.18, ministerioPublico: 21.18 },
  { de: 80000.01, ate: 85000, emolumentos: 215.19, estado: 41.67, ipesp: 22.38, registroCivil: 22.38, tribunalJustica: 22.38, ministerioPublico: 22.38 },
  { de: 85000.01, ate: 90000, emolumentos: 226.35, estado: 43.99, ipesp: 23.58, registroCivil: 23.58, tribunalJustica: 23.58, ministerioPublico: 23.58 },
  { de: 90000.01, ate: 95000, emolumentos: 237.51, estado: 46.31, ipesp: 24.78, registroCivil: 24.78, tribunalJustica: 24.78, ministerioPublico: 24.78 },
  { de: 95000.01, ate: 100000, emolumentos: 248.67, estado: 48.63, ipesp: 25.98, registroCivil: 25.98, tribunalJustica: 25.98, ministerioPublico: 25.98 },
  { de: 100000.01, ate: 125000, emolumentos: 284.27, estado: 56.55, ipesp: 29.58, registroCivil: 29.58, tribunalJustica: 29.58, ministerioPublico: 29.58 },
  { de: 125000.01, ate: 150000, emolumentos: 319.87, estado: 64.47, ipesp: 33.18, registroCivil: 33.18, tribunalJustica: 33.18, ministerioPublico: 33.18 },
  { de: 150000.01, ate: 175000, emolumentos: 355.47, estado: 72.39, ipesp: 36.78, registroCivil: 36.78, tribunalJustica: 36.78, ministerioPublico: 36.78 },
  { de: 175000.01, ate: 200000, emolumentos: 391.07, estado: 80.31, ipesp: 40.38, registroCivil: 40.38, tribunalJustica: 40.38, ministerioPublico: 40.38 },
  { de: 200000.01, ate: 225000, emolumentos: 426.67, estado: 88.23, ipesp: 43.98, registroCivil: 43.98, tribunalJustica: 43.98, ministerioPublico: 43.98 },
  { de: 225000.01, ate: 250000, emolumentos: 462.27, estado: 96.15, ipesp: 47.58, registroCivil: 47.58, tribunalJustica: 47.58, ministerioPublico: 47.58 },
  { de: 250000.01, ate: 275000, emolumentos: 497.87, estado: 104.07, ipesp: 51.18, registroCivil: 51.18, tribunalJustica: 51.18, ministerioPublico: 51.18 },
  { de: 275000.01, ate: 300000, emolumentos: 533.47, estado: 111.99, ipesp: 54.78, registroCivil: 54.78, tribunalJustica: 54.78, ministerioPublico: 54.78 },
  { de: 300000.01, ate: 325000, emolumentos: 569.07, estado: 119.91, ipesp: 58.38, registroCivil: 58.38, tribunalJustica: 58.38, ministerioPublico: 58.38 },
  { de: 325000.01, ate: 350000, emolumentos: 604.67, estado: 127.83, ipesp: 61.98, registroCivil: 61.98, tribunalJustica: 61.98, ministerioPublico: 61.98 },
  { de: 350000.01, ate: 375000, emolumentos: 640.27, estado: 135.75, ipesp: 65.58, registroCivil: 65.58, tribunalJustica: 65.58, ministerioPublico: 65.58 },
  { de: 375000.01, ate: 400000, emolumentos: 675.87, estado: 143.67, ipesp: 69.18, registroCivil: 69.18, tribunalJustica: 69.18, ministerioPublico: 69.18 },
  { de: 400000.01, ate: 425000, emolumentos: 711.47, estado: 151.59, ipesp: 72.78, registroCivil: 72.78, tribunalJustica: 72.78, ministerioPublico: 72.78 },
  { de: 425000.01, ate: 450000, emolumentos: 747.07, estado: 159.51, ipesp: 76.38, registroCivil: 76.38, tribunalJustica: 76.38, ministerioPublico: 76.38 },
  { de: 450000.01, ate: 475000, emolumentos: 782.67, estado: 167.43, ipesp: 79.98, registroCivil: 79.98, tribunalJustica: 79.98, ministerioPublico: 79.98 },
  { de: 475000.01, ate: 500000, emolumentos: 818.27, estado: 175.35, ipesp: 83.58, registroCivil: 83.58, tribunalJustica: 83.58, ministerioPublico: 83.58 },
  { de: 500000.01, ate: 550000, emolumentos: 884.27, estado: 191.15, ipesp: 89.58, registroCivil: 89.58, tribunalJustica: 89.58, ministerioPublico: 89.58 },
  { de: 550000.01, ate: 600000, emolumentos: 950.27, estado: 206.95, ipesp: 95.58, registroCivil: 95.58, tribunalJustica: 95.58, ministerioPublico: 95.58 },
  { de: 600000.01, ate: 650000, emolumentos: 1016.27, estado: 222.75, ipesp: 101.58, registroCivil: 101.58, tribunalJustica: 101.58, ministerioPublico: 101.58 },
  { de: 650000.01, ate: 700000, emolumentos: 1082.27, estado: 238.55, ipesp: 107.58, registroCivil: 107.58, tribunalJustica: 107.58, ministerioPublico: 107.58 },
  { de: 700000.01, ate: 750000, emolumentos: 1148.27, estado: 254.35, ipesp: 113.58, registroCivil: 113.58, tribunalJustica: 113.58, ministerioPublico: 113.58 },
  { de: 750000.01, ate: 800000, emolumentos: 1214.27, estado: 270.15, ipesp: 119.58, registroCivil: 119.58, tribunalJustica: 119.58, ministerioPublico: 119.58 },
  { de: 800000.01, ate: 850000, emolumentos: 1280.27, estado: 285.95, ipesp: 125.58, registroCivil: 125.58, tribunalJustica: 125.58, ministerioPublico: 125.58 },
  { de: 850000.01, ate: 900000, emolumentos: 1346.27, estado: 301.75, ipesp: 131.58, registroCivil: 131.58, tribunalJustica: 131.58, ministerioPublico: 131.58 },
  { de: 900000.01, ate: 950000, emolumentos: 1412.27, estado: 317.55, ipesp: 137.58, registroCivil: 137.58, tribunalJustica: 137.58, ministerioPublico: 137.58 },
  { de: 950000.01, ate: 1000000, emolumentos: 1478.27, estado: 333.35, ipesp: 143.58, registroCivil: 143.58, tribunalJustica: 143.58, ministerioPublico: 143.58 },
  { de: 1000000.01, ate: 1100000, emolumentos: 1610.27, estado: 365.15, ipesp: 155.58, registroCivil: 155.58, tribunalJustica: 155.58, ministerioPublico: 155.58 },
  { de: 1100000.01, ate: 1200000, emolumentos: 1742.27, estado: 396.95, ipesp: 167.58, registroCivil: 167.58, tribunalJustica: 167.58, ministerioPublico: 167.58 },
  { de: 1200000.01, ate: 1300000, emolumentos: 1874.27, estado: 428.75, ipesp: 179.58, registroCivil: 179.58, tribunalJustica: 179.58, ministerioPublico: 179.58 },
  { de: 1300000.01, ate: 1400000, emolumentos: 2006.27, estado: 460.55, ipesp: 191.58, registroCivil: 191.58, tribunalJustica: 191.58, ministerioPublico: 191.58 },
  { de: 1400000.01, ate: 1500000, emolumentos: 2138.27, estado: 492.35, ipesp: 203.58, registroCivil: 203.58, tribunalJustica: 203.58, ministerioPublico: 203.58 },
  { de: 1500000.01, ate: 1600000, emolumentos: 2270.27, estado: 524.15, ipesp: 215.58, registroCivil: 215.58, tribunalJustica: 215.58, ministerioPublico: 215.58 },
  { de: 1600000.01, ate: 1700000, emolumentos: 2402.27, estado: 555.95, ipesp: 227.58, registroCivil: 227.58, tribunalJustica: 227.58, ministerioPublico: 227.58 },
  { de: 1700000.01, ate: 1800000, emolumentos: 2534.27, estado: 587.75, ipesp: 239.58, registroCivil: 239.58, tribunalJustica: 239.58, ministerioPublico: 239.58 },
  { de: 1800000.01, ate: 1900000, emolumentos: 2666.27, estado: 619.55, ipesp: 251.58, registroCivil: 251.58, tribunalJustica: 251.58, ministerioPublico: 251.58 },
  { de: 1900000.01, ate: 2000000, emolumentos: 2798.27, estado: 651.35, ipesp: 263.58, registroCivil: 263.58, tribunalJustica: 263.58, ministerioPublico: 263.58 },
  { de: 2000000.01, ate: 2500000, emolumentos: 3308.27, estado: 746.95, ipesp: 311.58, registroCivil: 311.58, tribunalJustica: 311.58, ministerioPublico: 311.58 },
  { de: 2500000.01, ate: 3000000, emolumentos: 3818.27, estado: 842.55, ipesp: 359.58, registroCivil: 359.58, tribunalJustica: 359.58, ministerioPublico: 359.58 },
  { de: 3000000.01, ate: 3500000, emolumentos: 4328.27, estado: 938.15, ipesp: 407.58, registroCivil: 407.58, tribunalJustica: 407.58, ministerioPublico: 407.58 },
  { de: 3500000.01, ate: 4000000, emolumentos: 4838.27, estado: 1033.75, ipesp: 455.58, registroCivil: 455.58, tribunalJustica: 455.58, ministerioPublico: 455.58 },
  { de: 4000000.01, ate: 4500000, emolumentos: 5348.27, estado: 1129.35, ipesp: 503.58, registroCivil: 503.58, tribunalJustica: 503.58, ministerioPublico: 503.58 },
  { de: 4500000.01, ate: 5000000, emolumentos: 5858.27, estado: 1224.95, ipesp: 551.58, registroCivil: 551.58, tribunalJustica: 551.58, ministerioPublico: 551.58 },
  { de: 5000000.01, ate: 5500000, emolumentos: 6368.27, estado: 1320.55, ipesp: 600.58, registroCivil: 600.58, tribunalJustica: 600.58, ministerioPublico: 600.58 },
  { de: 5500000.01, ate: 6000000, emolumentos: 6878.27, estado: 1416.15, ipesp: 649.58, registroCivil: 649.58, tribunalJustica: 649.58, ministerioPublico: 649.58 },
  { de: 6000000.01, ate: 6500000, emolumentos: 7388.27, estado: 1511.75, ipesp: 698.58, registroCivil: 698.58, tribunalJustica: 698.58, ministerioPublico: 698.58 },
  { de: 6500000.01, ate: 7000000, emolumentos: 7898.27, estado: 1607.35, ipesp: 747.58, registroCivil: 747.58, tribunalJustica: 747.58, ministerioPublico: 747.58 },
  { de: 7000000.01, ate: 7500000, emolumentos: 8408.27, estado: 1702.95, ipesp: 796.58, registroCivil: 796.58, tribunalJustica: 796.58, ministerioPublico: 796.58 },
  { de: 7500000.01, ate: 8000000, emolumentos: 8918.27, estado: 1798.55, ipesp: 845.58, registroCivil: 845.58, tribunalJustica: 845.58, ministerioPublico: 845.58 },
  { de: 8000000.01, ate: 8500000, emolumentos: 9428.27, estado: 1894.15, ipesp: 894.58, registroCivil: 894.58, tribunalJustica: 894.58, ministerioPublico: 894.58 },
  { de: 8500000.01, ate: 9000000, emolumentos: 9938.27, estado: 1989.75, ipesp: 943.58, registroCivil: 943.58, tribunalJustica: 943.58, ministerioPublico: 943.58 },
  { de: 9000000.01, ate: 9500000, emolumentos: 10448.27, estado: 2085.35, ipesp: 992.58, registroCivil: 992.58, tribunalJustica: 992.58, ministerioPublico: 992.58 },
  { de: 9500000.01, ate: 10000000, emolumentos: 10958.27, estado: 2180.95, ipesp: 1041.58, registroCivil: 1041.58, tribunalJustica: 1041.58, ministerioPublico: 1041.58 },
  { de: 10000000.01, ate: Infinity, emolumentos: 11468.27, estado: 2276.55, ipesp: 1090.58, registroCivil: 1090.58, tribunalJustica: 1090.58, ministerioPublico: 1090.58 },
];

// Tabela de averbação (aproximadamente 50% dos valores de registro)
const TABELA_AVERBACAO = TABELA_REGISTRO.map(faixa => ({
  ...faixa,
  emolumentos: faixa.emolumentos * 0.5,
  estado: faixa.estado * 0.5,
  ipesp: faixa.ipesp * 0.5,
  registroCivil: faixa.registroCivil * 0.5,
  tribunalJustica: faixa.tribunalJustica * 0.5,
  ministerioPublico: faixa.ministerioPublico * 0.5,
}));

const explicacoesTaxas = {
  emolumentos: "Valor pago ao cartório pela prestação do serviço de registro. É a principal taxa cobrada pelos Ofícios de Registro de Imóveis.",
  estado: "Contribuição destinada ao Estado de São Paulo, calculada sobre o valor do imóvel conforme a Lei Estadual nº 11.331/2002.",
  ipesp: "Instituto de Previdência do Estado de São Paulo - contribuição previdenciária dos serventuários.",
  registroCivil: "Taxa destinada à complementação da remuneração dos registradores civis.",
  tribunalJustica: "Contribuição ao Tribunal de Justiça para manutenção dos serviços judiciários.",
  ministerioPublico: "Contribuição ao Ministério Público para fiscalização dos serviços notariais."
};

const formatarMoeda = (valor) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);
};

const TaxaItem = ({ nome, valor, explicacao, chave, showTooltip, setShowTooltip }) => (
  <div className="flex items-center justify-between py-3 border-b border-gray-100 last:border-0">
    <div className="flex items-center gap-2">
      <span className="text-gray-700 text-sm">{nome}</span>
      <button
        className="text-gray-400 hover:text-amber-600 transition-colors relative"
        onMouseEnter={() => setShowTooltip(chave)}
        onMouseLeave={() => setShowTooltip(null)}
        onClick={() => setShowTooltip(showTooltip === chave ? null : chave)}
      >
        <HelpCircle className="w-4 h-4" />
        {showTooltip === chave && (
          <div className="absolute left-0 bottom-full mb-2 w-64 p-3 bg-gray-900 text-white text-xs rounded-lg shadow-lg z-10">
            {explicacao}
            <div className="absolute left-3 bottom-0 transform translate-y-1/2 rotate-45 w-2 h-2 bg-gray-900"></div>
          </div>
        )}
      </button>
    </div>
    <span className="font-medium text-gray-900">{formatarMoeda(valor)}</span>
  </div>
);

const CalculadoraEmolumentos = () => {
  const [valorImovel, setValorImovel] = useState("");
  const [tipoAto, setTipoAto] = useState("registro");
  const [showTooltip, setShowTooltip] = useState(null);

  const handleValorChange = (e) => {
    let value = e.target.value.replace(/\D/g, '');
    if (value) {
      value = (parseInt(value) / 100).toFixed(2);
    }
    setValorImovel(value);
  };

  const valorNumerico = parseFloat(valorImovel) || 0;

  const calcularEmolumentos = (valor, tipo) => {
    if (valor <= 0) return null;

    const tabela = tipo === "registro" ? TABELA_REGISTRO : TABELA_AVERBACAO;
    const faixa = tabela.find(f => valor >= f.de && valor <= f.ate);
    
    if (!faixa) return null;

    const total = faixa.emolumentos + faixa.estado + faixa.ipesp + 
                  faixa.registroCivil + faixa.tribunalJustica + faixa.ministerioPublico;

    return {
      emolumentos: faixa.emolumentos,
      estado: faixa.estado,
      ipesp: faixa.ipesp,
      registroCivil: faixa.registroCivil,
      tribunalJustica: faixa.tribunalJustica,
      ministerioPublico: faixa.ministerioPublico,
      total
    };
  };

  const resultado = useMemo(() => {
    return calcularEmolumentos(valorNumerico, tipoAto);
  }, [valorNumerico, tipoAto]);

  return (
    <div className="bg-white rounded-2xl border border-gray-200 overflow-hidden" data-testid="calculadora-emolumentos">
      {/* Header */}
      <div className="bg-gradient-to-r from-amber-600 to-amber-700 p-6">
        <div className="flex items-center gap-3 text-white mb-2">
          <Calculator className="w-6 h-6" />
          <h3 className="text-xl font-bold">Calculadora de Emolumentos</h3>
        </div>
        <p className="text-amber-100 text-sm">
          Calcule os custos de registro de imóveis em São Paulo
        </p>
      </div>

      {/* Formulário */}
      <div className="p-6 space-y-5">
        {/* Valor do Imóvel */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Valor do Imóvel
          </label>
          <div className="relative">
            <span className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-500 font-medium">R$</span>
            <input
              type="text"
              value={valorImovel ? parseFloat(valorImovel).toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : ''}
              onChange={handleValorChange}
              placeholder="0,00"
              className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-amber-500 focus:border-amber-500 text-lg"
              data-testid="input-valor-imovel"
            />
          </div>
        </div>

        {/* Tipo de Ato */}
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-2">
            Tipo de Ato
          </label>
          <div className="grid grid-cols-2 gap-3">
            <button
              onClick={() => setTipoAto("registro")}
              className={`flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-all ${
                tipoAto === "registro"
                  ? "border-amber-600 bg-amber-50 text-amber-700"
                  : "border-gray-200 hover:border-gray-300 text-gray-600"
              }`}
              data-testid="btn-registro"
            >
              <FileText className="w-5 h-5" />
              <span className="font-medium">Registro</span>
            </button>
            <button
              onClick={() => setTipoAto("averbacao")}
              className={`flex items-center justify-center gap-2 px-4 py-3 rounded-lg border-2 transition-all ${
                tipoAto === "averbacao"
                  ? "border-amber-600 bg-amber-50 text-amber-700"
                  : "border-gray-200 hover:border-gray-300 text-gray-600"
              }`}
              data-testid="btn-averbacao"
            >
              <Home className="w-5 h-5" />
              <span className="font-medium">Averbação</span>
            </button>
          </div>
        </div>

        {/* Resultado */}
        {resultado && (
          <div className="mt-6 space-y-4" data-testid="resultado-calculo">
            {/* Card Total */}
            <div className="bg-gradient-to-br from-amber-50 to-orange-50 rounded-xl p-5 border border-amber-200">
              <p className="text-amber-700 text-sm font-medium mb-1">Valor Total Estimado</p>
              <p className="text-3xl font-bold text-amber-800">{formatarMoeda(resultado.total)}</p>
            </div>

            {/* Lista de Taxas */}
            <div className="bg-gray-50 rounded-xl p-4">
              <p className="text-sm font-semibold text-gray-700 mb-3 flex items-center gap-2">
                <Info className="w-4 h-4" />
                Detalhamento das Taxas
              </p>
              <div className="bg-white rounded-lg p-3">
                <TaxaItem 
                  nome="Emolumentos" 
                  valor={resultado.emolumentos} 
                  explicacao={explicacoesTaxas.emolumentos}
                  chave="emolumentos"
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                />
                <TaxaItem 
                  nome="Estado" 
                  valor={resultado.estado} 
                  explicacao={explicacoesTaxas.estado}
                  chave="estado"
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                />
                <TaxaItem 
                  nome="IPESP" 
                  valor={resultado.ipesp} 
                  explicacao={explicacoesTaxas.ipesp}
                  chave="ipesp"
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                />
                <TaxaItem 
                  nome="Registro Civil" 
                  valor={resultado.registroCivil} 
                  explicacao={explicacoesTaxas.registroCivil}
                  chave="registroCivil"
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                />
                <TaxaItem 
                  nome="Tribunal de Justiça" 
                  valor={resultado.tribunalJustica} 
                  explicacao={explicacoesTaxas.tribunalJustica}
                  chave="tribunalJustica"
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                />
                <TaxaItem 
                  nome="Ministério Público" 
                  valor={resultado.ministerioPublico} 
                  explicacao={explicacoesTaxas.ministerioPublico}
                  chave="ministerioPublico"
                  showTooltip={showTooltip}
                  setShowTooltip={setShowTooltip}
                />
              </div>
            </div>
          </div>
        )}

        {/* Nota de Rodapé */}
        <div className="pt-4 border-t border-gray-100">
          <p className="text-xs text-gray-500 flex items-start gap-2">
            <Info className="w-4 h-4 flex-shrink-0 mt-0.5" />
            <span>
              Valores baseados na <strong>Tabela II - Ofícios de Registro de Imóveis</strong> (ARISP), 
              conforme Lei Estadual nº 11.331/2002. Os valores são estimativas e podem variar 
              conforme o tipo específico de ato e condições do imóvel.
            </span>
          </p>
        </div>
      </div>
    </div>
  );
};

export default CalculadoraEmolumentos;
